export type LocalVisualCaptureDecision = "none" | "capture" | "return-to-execution";

export function stepProgressShouldBeForced(input: {
  phase: "direct" | "discovery" | "planning" | "execution" | "verification";
  hasActiveStep: boolean;
  executionEvidence: boolean;
  designApplied: boolean;
  qualityRequired: boolean;
  qualityComplete: boolean;
}): boolean {
  return input.phase === "execution"
    && input.hasActiveStep
    && input.executionEvidence
    && input.designApplied
    && (!input.qualityRequired || input.qualityComplete);
}

export function localVisualCaptureDecision(input: {
  sceneMutated: boolean;
  phase: "direct" | "discovery" | "planning" | "execution" | "verification";
  hasActiveStep: boolean;
  qualityRequired: boolean;
  designApplied: boolean;
  qualityComplete: boolean;
  reviewRequested: boolean;
  executionEvidence: boolean;
  reviewableCapturePending: boolean;
  onlyCoverageIssues: boolean;
  captureCalls: number;
  strategyLimit: number;
}): LocalVisualCaptureDecision {
  const needsCapture = input.sceneMutated
    && input.phase === "execution"
    && input.hasActiveStep
    && input.qualityRequired
    && input.designApplied
    && !input.qualityComplete
    // A etapa não depende de o modelo lembrar de solicitar a revisão. Quando
    // já existe execução concreta e todas as decisões estruturadas da etapa
    // foram aplicadas, o controlador abre o gate profissional por conta própria.
    && (input.reviewRequested || input.executionEvidence)
    && !input.reviewableCapturePending
    && input.onlyCoverageIssues;
  if (!needsCapture) return "none";
  return input.captureCalls >= input.strategyLimit ? "return-to-execution" : "capture";
}
